<template>
  <div :class="`text-xl font-bold text-${color} mb-1`">{{ text }}</div>
</template>

<script lang="ts">
  import { defineComponent } from 'vue'

  export default defineComponent({
    components: {
    },

    props: {
      text: {
        type: String,
        required: true,
      },

      color: {
        type: String,
        default: 'primary',
      },
    },
  })
</script>

<style scoped></style>
